<template>
  <div class="card border-inside">
    <div class="card-content">
      <div v-if="$i18n.locale === 'th'" class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Industry: </span
          >แสดงประเภทของผลิตภัณฑ์ของ Company (ผู้ประกอบการ) ทั้งหมดใน Batch
          (โครงการ) รูปแบบกราฟแท่งแกน x คือประเภทของผลิตภัณฑ์ ส่วนแกน y คือจำนวน
          Company (ผู้ประกอบการ) ซึ่งประเภทของผลิตภัณฑ์จะมีทั้งหมดดังนี้
        </p>
        <ul>
          <li>Food (การแปรรูปอาหาร)</li>
          <li>Smart Electronics (อิเล็กทรอนิกส์อัจฉริยะ)</li>
          <li>Digital(ดิจิทอล)</li>
          <li>
            Information & Communication
            Technology(เทคโนโลยีสารสนเทศและการสื่อสาร)
          </li>
          <li>Commerce (พาณิชย์หรือธุรกิจบริการออนไลน์)</li>
          <li>Business-to-business(ธุรกิจเพื่อผู้ประกอบธุรกิจ)</li>
          <li>Innovative Products(ผลิตภัณฑ์ที่ใช้นวัตกรรมเป็นจุดขาย)</li>
          <li>Robotics (หุ่นยนต์)</li>
          <li>
            Industrial Materials & Machine (วัสดุอุตสาหกรรมและเครื่องจักร)
          </li>
          <li>Construction Materials (วัสดุก่อสร้าง)</li>
          <li>Construction Services (บริการรับเหมาก่อสร้าง)</li>
          <li>Lifestyle Products (ของใช้ในครัวเรือน หัตถกรรม และสำนักงาน)</li>
          <li>Fashion (แฟชั่น สิ่งทอ เครื่องนุ่งห่ม)</li>
          <li>Gem and Jewelry (อัญมณีและเครื่องประดับ)</li>
          <li>Design Services (รับจ้างออกแบบ)</li>
          <li>Packaging (บรรจุภัณฑ์)</li>
          <li>Media & Publishing (สื่อและสิ่งพิมพ์)</li>
          <li>Next – Generation Automotive (ยานยนต์สมัยใหม่)</li>
          <li>Aviation and Logistics (การบินและโลจิสติกส์)</li>
          <li>Biofuels and Biochemicals (เชื้อเพลิงชีวภาพและเคมีชีวภาพ)</li>
          <li>
            Affluent, Medical and Wellness Tourism
            (การท่องเที่ยวกลุ่มรายได้ดีและการท่องเที่ยวเชิงสุขภาพ)
          </li>
          <li>Agriculture and Biotechnology (การเกษตรและเทคโนโลยีชีวภาพ)</li>
          <li>Rubber Innovation (นวัตกรรมยางพารา)</li>
          <li>Medical Hub (การแพทย์ครบวงจร)</li>
          <li>Cosmetics (ธุรกิจเครื่องสำอาง)</li>
          <li>Consultant (ที่ปรึกษา)</li>
          <li>Finance & Securities (เงินทุนและหลักทรัพย์)</li>
          <li>Insurance (ประกันภัยและประกันชีวิต)</li>
          <li>Property Development (พัฒนาอสังหาริมทรัพย์)</li>
          <li>Education (การศึกษา)</li>
          <li>Mining (เหมืองแร่)</li>
          <li>Other (ด้านอื่น ๆ)</li>
        </ul>
      </div>
      <div v-else class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Industry: </span>Displaying the
          types of products of companies in the batch project in a bar graph
          format, where the x-axis represents the product categories and the
          y-axis represents the number of companies. The product categories
          include
        </p>
        <ul>
          <li>Food (Food processing)</li>
          <li>Smart Electronics</li>
          <li>Digital</li>
          <li>Information & Communication Technology</li>
          <li>Commerce (Online commerce or e-commerce)</li>
          <li>Business-to-business</li>
          <li>Innovative Products</li>
          <li>Robotics</li>
          <li>Industrial Materials & Machine</li>
          <li>Construction Materials</li>
          <li>Construction Services</li>
          <li>
            Lifestyle Products (Household, handicrafts, and office supplies)
          </li>
          <li>Fashion (Fashion, textiles, and garments)</li>
          <li>Gem and Jewelry</li>
          <li>Design Services</li>
          <li>Packaging</li>
          <li>Media & Publishing</li>
          <li>Next-Generation Automotive</li>
          <li>Aviation and Logistics</li>
          <li>Biofuels and Biochemicals</li>
          <li>Affluent, Medical and Wellness Tourism</li>
          <li>Agriculture and Biotechnology</li>
          <li>Rubber Innovation</li>
          <li>Medical Hub</li>
          <li>Cosmetics</li>
          <li>Consultant</li>
          <li>Finance & Securities</li>
          <li>Insurance</li>
          <li>Property Development</li>
          <li>Education</li>
          <li>Mining</li>
          <li>Other</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>